document.addEventListener("DOMContentLoaded", (event) => {
  if (window.innerWidth < 990) {
    const footerMenuHeadingWrapper = document.querySelector('.footer__blocks-wrapper');

    footerMenuHeadingWrapper.addEventListener('click', (e) => {

      const el = e.target;

      if (el.className.includes('footer-block__button-heading')) {
        
        if (el.className.includes('active')) {
          el.classList.remove('active');
        } else {
          el.classList.add('active');
        }
      }
    });
  }
});